export default __webpack_public_path__ + "images/SpeakersPhotos/Alvaro_Alegria.jpg?23009719";